import { LogoBox } from 'components/styles_components/box';
import logo from 'assets/images/logo.png';

const Logo = ({ width = 200, className = '', children }) => {
  return (
    <LogoBox className={className}>
      <img src={logo} alt="Logo" width={width} />
      {children}
    </LogoBox>
  );
};

export default Logo;
